import './App.css';
import { Routes, Route } from 'react-router-dom';
import XLindex from './components/XLindex';
import XLproduct from './components/XLproduct';
import XLintroduce from './components/XLintroduce';
import XLcontact from './components/XLcontact';
import XLjoin from './components/XLjoin';

/**
 * 招聘邮箱
 */
export const hrMail = 'xulieaizp@163.com';
/**
 * 客户支持联系邮箱
 */
export const supportMail = 'xuliesupport@163.com';


function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<XLindex />} />
        <Route path="/products" element={<XLproduct />} />
        <Route path="/about" element={<XLintroduce />} />
        <Route path="/contact" element={<XLcontact />} />
        <Route path="/join" element={<XLjoin />} />
      </Routes>
    </div>
  );
}

export default App;
